import * as React from 'react';
import { Tooltip } from '@cian/ui-kit/prev';
import { Label } from './Label';
import * as styles from './FloatingLabel.css';

export interface IFloatingLabelProps {
  labelText: string;
  tooltipTitle: string;
  tooltipText: string;
}

export function FloatingLabel(props: IFloatingLabelProps) {
  const { labelText, tooltipText, tooltipTitle } = props;

  return (
    <div className={styles['container']}>
      <Tooltip master={<Label labelText={labelText} />}>
        <div className={styles['title']}>{tooltipTitle}</div>
        <div className={styles['text']}>{tooltipText}</div>
      </Tooltip>
    </div>
  );
}
